import axios from 'axios';

export const baseURL = process.env.REACT_APP_API_URL;
export const Api = axios.create({
	baseURL: baseURL,
	headers: {
		'Content-Type': 'application/json',
		accept: 'application/json',
	},
});

export {
	Login,
	LoginAdmin,
	Register,
	RegisterClient,
	ReverifyEmail,
	RefreshToken,
	VerifyEmail,
	Logout,
	ForgetPassword,
	PasswordReset,
	CheckEmail,
} from './auth.api';

export {
	GetClientAdmins,
	GetClientUsers,
	CreateAdmin,
	CreateUser,
	EditClientUser,
	EditAdminUser,
} from './admin.api';

export {
	createCandidate,
	getCandidatesList,
	getCandidateData,
	getSummaryCount,
	getCandidateSummary,
	addToArchive,
	addJobHistory,
	getJobHistory,
	getJobHistorybyId,
	updateCandidateJobHistory,
	removeJobHistory,
	sendEmail,
	addQuestionnaireResponse,
	getQuestionnaireResponse,
	updateLifeCycle,
	sendCompleteEmail,
	getCandidateLifeCycle,
	sendRefereeDeclineMail,
	getPDF,
} from './user.api';

export {
	GetClients,
	GetAllUsers,
	GetClientObjectUUID,
	PostClientObject,
	CreateClientUsers,
	EditClientUsers,
	EditClient,
	FilterUser,
	FilterClients,
	GetReports,
} from './super_admin.api';
